/* eslint-disable */
import React from "react";
import { useState, useEffect } from "react";
import "antd/dist/antd.css";
import "./App.css";
import { useLocation, useParams } from "react-router-dom";
import Widget from "./components/Widget";
import BarLoader from "react-spinners/BarLoader";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchWidgetJSON,
  resetCurrentFeedbackScore,
  setRateParam,
  setSessionId,
} from "Redux/actions";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import PageLoader from "components/PageLoader";
import ErrorPage from "components/ErrorPage";

function useQuery(search, param) {
  return new URLSearchParams(search).get(param);
}

const App = () => {
  const { widgetJSON, currentPage, isErrorPage } = useSelector(
    (state) => state
  );
  const location = useLocation();
  const dispatch = useDispatch();
  const uid = location.pathname.split("/").join("");
  const rateParams = useQuery(location.search, "r");

  useEffect(() => {
    document.querySelector("html").scrollTop = 0;
    document.querySelector("body").scrollTop = 0;
  }, [currentPage]);

  useEffect(() => {
    if (location.pathname.length > 1) {
      dispatch(fetchWidgetJSON(uid));
      if (rateParams) {
        dispatch(setRateParam(rateParams));
      }
    }
  }, []);

  return isErrorPage ? (
    <ErrorPage />
  ) : widgetJSON.isLinkActive ? (
    <Widget />
  ) : (
    <PageLoader />
  );
};

export default App;
